import {
  GET_CONTENTCATEGORY,
  GET_CONTENTCATEGORY_SUCCESS,
  GET_CONTENTCATEGORY_FAIL,
  DELETE_CONTENTCATEGORY,
  DELETE_CONTENTCATEGORY_SUCCESS,
  DELETE_CONTENTCATEGORY_FAIL,
  UPDATE_CONTENTCATEGORY,
  UPDATE_CONTENTCATEGORY_SUCCESS,
  UPDATE_CONTENTCATEGORY_FAIL,
  ADD_NEW_CONTENTCATEGORY,
  ADD_CONTENTCATEGORY_SUCCESS,
  ADD_CONTENTCATEGORY_FAIL,
  CONTENTCATEGORY_LOADING,
  CONTENTCATEGORY_RESET
} from "./actionType";

export const resetContentCategoryState = (actionType) => ({
  type: CONTENTCATEGORY_RESET,
  payload: { actionType },
});

export const getContentCategorySuccess = (actionType, data) => ({
  type: GET_CONTENTCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getContentCategoryFail = (actionType, error) => ({
  type: GET_CONTENTCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getContentCategory = data => ({
  type: GET_CONTENTCATEGORY,
  payload: data,
});

export const getContentCategoryLoading = () => ({
  type: CONTENTCATEGORY_LOADING
});

export const deleteContentCategory = data => ({
  type: DELETE_CONTENTCATEGORY,
  payload: data,
});

export const deleteContentCategorySuccess = data => ({
  type: DELETE_CONTENTCATEGORY_SUCCESS,
  payload: data,
});

export const deleteContentCategoryFail = error => ({
  type: DELETE_CONTENTCATEGORY_FAIL,
  payload: error,
});

export const updateContentCategory = data => ({
  type: UPDATE_CONTENTCATEGORY,
  payload: data,
});

export const updateContentCategoryFail = error => ({
  type: UPDATE_CONTENTCATEGORY_FAIL,
  payload: error,
});

export const updateContentCategorySuccess = data => ({
  type: UPDATE_CONTENTCATEGORY_SUCCESS,
  payload: data,
});

export const addNewContentCategory = data => ({
  type: ADD_NEW_CONTENTCATEGORY,
  payload: data,
});

export const addContentCategorySuccess = data => ({
  type: ADD_CONTENTCATEGORY_SUCCESS,
  payload: data,
});

export const addContentCategoryFail = error => ({
  type: ADD_CONTENTCATEGORY_FAIL,
  payload: error,
});